import { FC } from "react";
import { useField, useFormikContext } from "formik";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  FormHelperText,
  RadioGroup,
  Radio,
} from "@mui/material";

interface IRadioInput {
  name: string;
  label: string;
  disabled?: boolean;
  radioGroup?: any;
}

const RadioInput: FC<IRadioInput> = ({
  name,
  label,
  disabled,
  radioGroup,
  ...otherProps
}) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = (evt: any) => {
    const { value } = evt.target;
    setFieldValue(name, value);
  };

  const configRadio = {
    ...field,
    value: field.value,
    onChange: handleChange,
    disabled: disabled ? disabled : false,
  };

  const configFormControl = { error: false };
  const configFormHelperText: any = { helperText: "" };
  if (meta && (meta.touched || meta.error)) {
    configFormControl.error = meta.error ? true : false;
    configFormHelperText.helperText = meta.error;
  }

  return (
    <FormControl {...configFormControl}>
      <FormLabel>{label}</FormLabel>
      <RadioGroup row {...configRadio}>
        {radioGroup.map((radio: any, index: number) => (
          <FormControlLabel
            key={index}
            value={radio.value}
            control={<Radio />}
            label={radio.label}
          />
        ))}
      </RadioGroup>
      <FormHelperText> {configFormHelperText.helperText} </FormHelperText>
    </FormControl>
  );
};

export default RadioInput;
